if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
        });
      }

      this._autoplayMs = (parseInt(this.dataset.autorotateInterval, 10) || 5) * 1000;
      this._enabled = this.dataset.autorotateEnable === 'true'
        && this.length > 1
        && !(window.Shopify && window.Shopify.designMode)
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if ( this._enabled ) {
        const init = () => this._setupAutoplay();
        if ( 'requestIdleCallback' in window ) {
          requestIdleCallback(init, { timeout: 1000 });
        } else {
          setTimeout(init, 0);
        }
      }

    }

    changeSlide(direction) {

      this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        this.index++;
      } else if ( direction == 'prev' ) {
        this.index--;
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled')
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled')
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

      if ( this._enabled ) this._scheduleNext();

    }

    _setupAutoplay() {
      this._pauseReasons = new Set();
      this._scheduleNext();

      this._onVisibility = () => {
        if ( document.hidden ) this._pause('hidden');
        else this._resume('hidden');
      };
      document.addEventListener('visibilitychange', this._onVisibility);

      this._onEnter = () => this._pause('hover');
      this._onLeave = () => this._resume('hover');
      this.addEventListener('pointerenter', this._onEnter);
      this.addEventListener('pointerleave', this._onLeave);

      this._io = new IntersectionObserver(([entry]) => {
        if ( entry.isIntersecting ) this._resume('offscreen');
        else this._pause('offscreen');
      }, { threshold: 0 });
      this._io.observe(this);
    }

    _pause(reason) {
      if ( !this._pauseReasons ) return;
      this._pauseReasons.add(reason);
      clearTimeout(this._timer);
    }

    _resume(reason) {
      if ( !this._pauseReasons ) return;
      this._pauseReasons.delete(reason);
      if ( this._pauseReasons.size === 0 ) this._scheduleNext();
    }

    _scheduleNext() {
      clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        const next = (this.index + 1) % this.length;
        this._goTo(next);
        this._scheduleNext();
      }, this._autoplayMs);
    }

    _goTo(i) {
      this.index = i;
      this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled');
      if ( this.index === this.length - 1 ) this.nextButton.classList.add('announcement-bar__content-nav--disabled');
      if ( this.index === 0 ) this.prevButton.classList.add('announcement-bar__content-nav--disabled');
      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

    disconnectedCallback() {
      clearTimeout(this._timer);
      if ( this._onVisibility ) document.removeEventListener('visibilitychange', this._onVisibility);
      if ( this._io ) this._io.disconnect();
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}